import React, { useMemo } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import PageHeader from "components/ui/PageHeader";
import tenantRoutes from "tenantRoutes";
import useCurrentUser from "hooks/useCurrentUser";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const TenantLayout = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { user } = useCurrentUser() || {};

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((prop, key) =>
      prop.layout === "/tenant" ? (
        <Route path={prop.path} element={prop.component} key={key} />
      ) : null
    );

  const sidebarRoutes = useMemo(
    () => tenantRoutes.filter((r) => r.sidebar !== false),
    []
  );

  const brandText = useMemo(() => {
    for (let r of tenantRoutes) {
      if (location.pathname.includes((r.layout || "") + r.path)) return r.name;
    }
    return "Tenant";
  }, [location.pathname]);

  const tenantName = user?.tenant?.name || "Organization";
  const userName = user?.firstName || (user?.username ? user.username.split("@")[0] : "");

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/tenant/dashboard" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/tenant/Profile" />
        <PageHeader
          role="tenant"
          eyebrow={`${tenantName} · Tenant`}
          title={userName ? `${greeting()}, ${userName}` : brandText}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Routes>
            {getRoutes(tenantRoutes)}
            <Route path="*" element={<Navigate to="/tenant/dashboard" replace />} />
          </Routes>
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default TenantLayout;
